import React, { createContext, useContext, useState, useEffect } from "react";
import authService from "./authService";

// Creating a Cart Context
const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]); // Store items in the cart
  const [cartCount, setCartCount] = useState(0); // Store the number of items in the cart

  const fetchCartCount = async () => {
    const user = authService.getCurrentuser();
    const token = authService.getCurrentUsertoken();
  
    if (!user || !token) return;
  
    try {
      const res = await fetch(authService.getApiUrl() + "countcart", {
        method: "POST",
        body: JSON.stringify({
          organization_id: 1, // or use a dynamic value if needed
          user_id: user.id,
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (res.status === 401) {
        authService.clientlogout();
        window.location.href = "/login";
        return;
      }
  
      const result = await res.json();
      setCartCount(result.data[0].cart_count || 0);
    } catch (error) {
      console.error("Failed to fetch cart count:", error.message);
    }
  };

  // Function to add item to the cart
  const addItem = (item) => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find((cartItem) => cartItem.id === item.id);
      if (existingItem) {
        // If item already exists, just increase the quantity
        return prevItems.map((cartItem) =>
          cartItem.id === item.id
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        );
      } else {
        // If item doesn't exist, add it to the cart
        return [...prevItems, { ...item, quantity: 1 }];
      }
    });
  };

  // Function to remove item from the cart
  const removeItem = (id) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  // Function to update the cart count
  const updateCartCount = () => {
    setCartCount(cartItems.length);
  };

  useEffect(() => {
    fetchCartCount();
  }, []);

  useEffect(() => {
    updateCartCount(); // Update cart count whenever items change
  }, [cartItems]);

  return (
    <CartContext.Provider
      value={{ cartItems, cartCount, setCartCount, fetchCartCount, addItem, removeItem }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
